function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 11 11",
  className: (styles["hbs-cta-link__icon"] || "hbs-cta-link__icon") + " " + (styles["hbs-cta-link__icon--download"] || "hbs-cta-link__icon--download"),
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  className: styles["download-arrow-path"] || "download-arrow-path",
  d: "M4.775 0v5.96l-2.75-2.881L1 4.153l4.5 4.714L10 4.153 8.975 3.079l-2.75 2.88V0h-1.45z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 9.429V11h9V9.429H1z",
  fill: "currentColor"
})));